export default function ArrowSvg({color='#7FC9A0'}) {
  return <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L6.72389 8.04478C7.12408 8.53733 7.87592 8.53733 8.27611 8.04478L14 1" stroke={color} strokeWidth="1.5"/>
  </svg>
}